import styled from "@emotion/styled";

export const LocationModalWrapper = styled.div`
  width: 500px;
`;
